import { Controller } from "@hotwired/stimulus"

// data-controller="sidebar"
export default class extends Controller {
  static targets = ["panel", "content", "toggleButton"]

  connect() {
    this.isOpen = true
    this.updateState()
  }

  toggle() {
    this.isOpen = !this.isOpen
    this.updateState()
  }

  updateState() {
    // --- Sidebar open ---
    if (this.isOpen) {
      this.panelTarget.classList.remove("-translate-x-full")
      this.panelTarget.classList.add("translate-x-0")

      this.contentTarget.classList.add("pl-72")
      this.contentTarget.classList.remove("pl-4")

      this.toggleButtonTarget.style.display = "none"

    // --- Sidebar closed ---
    } else {
      this.panelTarget.classList.add("-translate-x-full")
      this.panelTarget.classList.remove("translate-x-0")

      this.contentTarget.classList.remove("pl-72")
      this.contentTarget.classList.add("pl-4")

      this.toggleButtonTarget.style.display = "block"
    }
  }
}
